import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";

// Action Types
export const GET_TIMETABLE_URL_SUCCESS = "GET_TIMETABLE_URL_SUCCESS";
export const GET_TIMETABLE_URL_ERROR = "GET_TIMETABLE_URL_ERROR";

export const getTimetableUrl = createAsyncThunk(
    "api/Calendar/getTimetableUrl",
    async (_, { dispatch }) => {
        try {
            const response = await axios.get(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/getTimetableUrl`
            );

            dispatch({
                type: GET_TIMETABLE_URL_SUCCESS,
                payload: response.data.url // We expect { url: "..." }
            });

        } catch (error) {
            dispatch({ type: GET_TIMETABLE_URL_ERROR, payload: error.message });
        }
    }
);